import SectionHeader from './section-header';
import Item from './item';

SectionHeader.Item = Item;
export default SectionHeader;
